module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-kpito-intro-card1.1@2x.ec43ad39.jpg";